import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'Home',
		component: HomeView
	},
	// 产品管理路由
	{
		path: '/products',
		name: 'Products',
		redirect: '/products/sbfw'
	},
	{ //招聘信息
		path: '/recruitment',
		name: 'recruitment',
		component: () => import( /* webpackChunkName: "recruitment" */ '../views/recruitment.vue')
	},
	{ //详情页
		path: '/details',
		name: 'detailsPage',
		component: () => import( /* webpackChunkName: "products" */ '../views/details.vue')
	},
	{ //商标服务
		path: '/products/sbfw',
		name: 'sbfw',
		component: () => import( /* webpackChunkName: "products" */ '../views/products/sbfw.vue')
	},
	{ //专利服务
		path: '/products/zlfw',
		name: 'zlfw',
		component: () => import( /* webpackChunkName: "products" */ '../views/products/zlfw.vue')
	},
	{ //法律服务
		path: '/products/flfw',
		name: 'flfw',
		component: () => import( /* webpackChunkName: "products" */ '../views/products/flfw.vue')
	},
	{ //项目申报
		path: '/products/xmsb',
		name: 'xmsb',
		component: () => import( /* webpackChunkName: "products" */ '../views/products/xmsb.vue')
	},
	{ //智慧园区建设
		path: '/products/zhyy',
		name: 'zhyy',
		component: () => import( /* webpackChunkName: "products" */ '../views/products/zhyy.vue')
	},
	{ //3D打印机及产品生产销售
		path: '/products/3dprint',
		name: '3dprint',
		component: () => import( /* webpackChunkName: "products" */ '../views/products/3dprint.vue')
	},
	{ //AI智能系统
		path: '/products/ai',
		name: 'ai',
		component: () => import( /* webpackChunkName: "products" */ '../views/products/ai.vue')
	},
	{ //新能源（工商业储能）
		path: '/products/xny',
		name: 'xny',
		component: () => import( /* webpackChunkName: "products" */ '../views/products/xny.vue')
	},
	{ //直播电商
		path: '/products/zbds',
		name: 'zbds',
		component: () => import( /* webpackChunkName: "products" */ '../views/products/zbds.vue')
	},
	{ //乡村振兴专项服务
		path: '/products/xczx',
		name: 'xczx',
		component: () => import( /* webpackChunkName: "products" */ '../views/products/xczx.vue')
	},
	{ //财税及金融服务
		path: '/products/csjrw',
		name: 'csjrw',
		component: () => import( /* webpackChunkName: "products" */ '../views/products/csjrw.vue')
	},
	{ //公司简介
		path: '/aboutUs/gsjj',
		name: 'gsjj',
		component: () => import( /* webpackChunkName: "users" */ '../views/aboutUs/gsjj.vue')
	},
	{ //发展历程
		path: '/aboutUs/fzlc',
		name: 'fzlc',
		component: () => import( /* webpackChunkName: "users" */ '../views/aboutUs/fzlc.vue')
	},
	{ //新闻资讯
		path: '/news/newsList',
		name: 'newsList',
		component: () => import( /* webpackChunkName: "users" */ '../views/news/newsList.vue')
	},
	{ //联系我们
		path: '/AboutView',
		name: 'lxwm',
		component: () => import( /* webpackChunkName: "users" */ '../views/AboutView.vue')
	},
	{ //案例中心
		path: '/caseCenter/khal',
		name: 'caseCenter',
		component: () => import( /* webpackChunkName: "users" */ '../views/caseCenter/khal')
	},
	{ //党建专栏
		path: '/partyBuilding/djzl',
		name: 'partyBuilding',
		component: () => import( /* webpackChunkName: "users" */ '../views/partyBuilding/djzl')
	},
	{ //视频
		path: '/video',
		name: 'video',
		component: () => import( /* webpackChunkName: "users" */ '../views/video')
	},
	{ //集团荣誉
		path: '/honor',
		name: 'honor',
		component: () => import( /* webpackChunkName: "users" */ '../views/honor')
	}
]

const router = new VueRouter({
	mode: 'history', // 使用history模式,URL更简洁,适合SEO
	base: process.env.BASE_URL,
	routes,
	linkActiveClass: 'router-link-active',
	linkExactActiveClass: 'router-link-exact-active',
	// 添加滚动行为,确保页面跳转后滚动到顶部
	scrollBehavior(to, from, savedPosition) {
		// 如果有保存的位置(浏览器前进后退),则返回保存的位置
		if (savedPosition) {
			return savedPosition
		}
		// 否则滚动到顶部
		return { x: 0, y: 0 }
	}
})

// 添加路由守卫防止重复导航
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => {
		if (err.name !== 'NavigationDuplicated') throw err
	})
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch(err => {
		if (err.name !== 'NavigationDuplicated') throw err
	})
}

export default router